import script from "./AppointmentDurationSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentDurationSection.vue?vue&type=script&setup=true&lang=js"

import "./AppointmentDurationSection.vue?vue&type=style&index=0&id=43322f18&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43322f18"]])

export default __exports__